import Vue from 'vue'

import SelectList from '@/components/base/select/SelectList'
import SelectOption from '@/components/base/select/SelectOption'

Vue.component(SelectList.name, SelectList)
Vue.component(SelectOption.name, SelectOption)
